import React from 'react';
import './card.css';

/** Generic content panel — the neutral container for anything that is
 *  not a table. */
export default function Card({ title, actions, children, padded = true }) {
  return (
    <div className="ui-card">
      {(title || actions) && (
        <div className="ui-card-head">
          {title && <h3 className="ui-card-title">{title}</h3>}
          {actions && <div className="ui-card-actions">{actions}</div>}
        </div>
      )}
      <div className={padded ? 'ui-card-body' : ''}>{children}</div>
    </div>
  );
}

/** A single headline number. Used by dashboards and summary rows
 *  (~14 screens in the old app, each with its own card CSS). */
export function StatCard({ label, value, icon, tone = 'neutral', hint }) {
  return (
    <div className={`ui-stat ui-stat-${tone}`}>
      {icon && <div className="ui-stat-icon">{icon}</div>}
      <div className="ui-stat-text">
        <span className="ui-stat-value">{value}</span>
        <span className="ui-stat-label">{label}</span>
        {hint && <span className="ui-stat-hint">{hint}</span>}
      </div>
    </div>
  );
}

/** Auto-fitting row of StatCards. */
export function StatGrid({ children }) {
  return <div className="ui-stat-grid">{children}</div>;
}

/** Shown when a screen has nothing to display — the standalone twin of
 *  the table's built-in empty message. */
export function EmptyState({ icon = '📭', title, message, action }) {
  return (
    <div className="ui-empty">
      <div className="ui-empty-icon">{icon}</div>
      {title && <p className="ui-empty-title">{title}</p>}
      {message && <p className="ui-empty-message">{message}</p>}
      {action}
    </div>
  );
}
